export const IsHost = [
    {
        destinationcity_name: ['ONNE', 'LOME', 'APAPA', 'TEMA', 'TINCAN', 'LAGOS', 'COTONOU', 'ABIDJAN'],
        host: '西非基本港',
    },
    {
        destinationcity_name: ['DAKAR', 'CONAKRY', 'BANJUL', 'NOUADHIBOU', 'MONROVIA', 'FREETOWN', 'NOUAKCHOTT', 'PRAIA', 'TIN CAN ISLAND PORT'],
        host: '西非北港',
    },
    {
        destinationcity_name: ['LUANDA', 'MATADI', 'DOUALA', 'POINTE NOIRE', 'LIBREVILLE', 'BATA', 'WALVIS BAY', 'KRIBI'],
        host: '西非南港',
    },
    {
        destinationcity_name: [
            'CAPE TOWN',
            'MASERU',
            'DURBAN',
            'JOHANNESBURG',
            'BLANTYRE',
            'MATSAPHA',
            'PORT LOUIS',
            'MAPUTO',
            'GABORONE',
            'BEIRA',
            'HARARE',
        ],
        host: '南非',
    },
    {
        destinationcity_name: [
            'SALALAH',
            'ADEN',
            'HODEIDAH',
            'CHITTAGONG',
            'BEKASI',
            'JEBEL ALI',
            'COLOMBO',
            'KARACHI',
            'JAWAHARLAL NEHRU',
            'NHAVA SHEVA',
            'DAMMAM',
            'BIRGANJ',
            'JEDDAH',
            'AQABA',
            'MUNDRA',
            'RIYADH'
        ],
        host: '中红印',
    },
    {
        destinationcity_name: [
            'MOGADISHU',
            'BERBERA',
            'DJIBOUTI',
            'NAIROBI',
            'ZANZIBAR',
            'LUSAKA',
            'MOMBASA',
            'DAR ES SALAAM',
            'KAMPALA',
            'TOAMASINA',
            'LILONGWE',
            'Dar_Es_Salaam',
        ],
        host: '东非',
    },
    {
        destinationcity_name: [
            'BEJAIA',
            'ASHDOD',
            'HAIFA',
            'BARCELONA',
            'NAPLES',
            'LA SPEZIA',
            'VALENCIA',
            'KOPER',
            'RIJEKA',
            'PIRAEUS',
            'VARNA',
            'MERSIN',
            'ISKENDERUN',
            'IZMIR',
            'ALEXANDRIA DEKHEILA',
            'THESSALONIKI',
            'AMBARLI',
            'IZMIT KORFEZI',
            'BURGAS',
            'POTI',
            'CONSTANTA',
            'SOFIA',
            'PORT TANGIER',
            'CASABLANCA',
            'MISURATAH',
            'BENGHAZI',
            'ORAN',
            'ALGIERS PORT',
            'ALGECIRAS',
            'GIOIA TAURO',
            'CASABLANCA RAIL',
            'PORT SAID WEST',
            'ALEXANDRIA OLD PORT',
            'TRIESTE',
            'PORT TANGIER MEDITERRANEE',
            'ALEXANDRIA',
            'AMBARLI PORT ISTANBUL',
            'LEIXOES',
        ],
        host: '地中海',
    },
    {
        destinationcity_name: [
            'NEWARK',
            'SAVANNAH',
            'LONG BEACH',
            'OAKLAND',
            'LOS ANGELES',
            'HOUSTON',
            'MIAMI',
            'CHICAGO',
            'MEMPHIS',
            'VANCOUVER',
            'TORONTO',
            'VANCOUVER',
            'BALTIMORE',
            'CHARLESTON',
            'NORFOLK',
            'JACKSONVILLE',
            'CHARLOTTE',
            'MOBILE',
            'HALIFAX',
        ],
        host: '美加',
    },
    {
        destinationcity_name: [
            'GDANSK',
            'LIVERPOOL',
            'FELIXSTOWE',
            'ROTTERDAM',
            'RIGA',
            'HAMBURG',
            'ANTWERP',
            'LONDON GATEWAY PORT',
            'BASEL',
            'LE HAVRE',
            'BREMERHAVEN',
            'ALTENA',
            'BODOE',
            'GOTHENBURG',
            'TALLINN',
            'SOUTHAMPTON',
        ],
        host: '欧洲',
    },
    {
        destinationcity_name: ['SANTOS', 'BUENOS AIRES', 'ITAPOA', 'MONTEVIDEO', 'VITORIA', 'PARANAGUA', 'MANAUS'],
        host: '南美东',
    },
    {
        destinationcity_name: [
            'CAUCEDO',
            'CARTAGENA',
            'KINGSTON',
            'COLON FREE ZONE',
            'PUERTO CALDERA',
            'SAN JOSE',
            'ACAJUTLA',
            'CORINTO',
            'PARAMARIBO',
            'PUERTO CORTES',
            'GEORGETOWN',
            'PUERTO CABELLO',
            'RIO HAINA',
            'LA GUAIRA',
        ],
        host: '加勒比',
    },
    {
        destinationcity_name: [
            'CALLAO',
            'SAN ANTONIO',
            'BUENAVENTURA',
            'GUAYAQUIL',
            'MALE',
            'MANZANILLO,MEXICO',
            'TOLUCA',
            'MEXICO CITY',
            'LAZARO CARDENAS',
            'BALBOA',
            'ARICA',
            'MELNIK',
        ],
        host: '南美西',
    },
    {
        destinationcity_name: ['MELBOURNE', 'SYDNEY', 'BRISBANE'],
        host: '澳新',
    },
    {
        destinationcity_name: ['JAKARTA', 'SEMARANG', 'HO CHI MINH', 'PORT KLANG', 'HAIPHONG', 'SINGAPORE', 'BANGKOK', 'HO CHI MINH CITY'],
        host: '东南亚',
    },
];
